import { differenceInCalendarDays, format } from "date-fns";
import { ptBR } from "date-fns/locale";
import { dateOnlyToDate } from "@/lib/format.ts";

const percentFormatter = new Intl.NumberFormat("pt-BR", {
	style: "percent",
	maximumFractionDigits: 0,
});

const preciseFormatter = new Intl.NumberFormat("pt-BR", {
	style: "percent",
	maximumFractionDigits: 1,
});

const pointsFormatter = new Intl.NumberFormat("pt-BR", {
	maximumFractionDigits: 1,
	signDisplay: "exceptZero",
});

const gapFormatter = new Intl.NumberFormat("pt-BR", {
	maximumFractionDigits: 1,
});

const countFormatter = new Intl.NumberFormat("pt-BR");

export function formatPercent(value: number): string {
	return percentFormatter.format(value / 100);
}

export function formatPrecisePercent(value: number): string {
	return preciseFormatter.format(value / 100);
}

export function formatPointsValue(value: number): string {
	return pointsFormatter.format(value);
}

export function formatPoints(value: number): string {
	return `${formatPointsValue(value)} p.p.`;
}

export function formatGapPoints(value: number): string {
	return `${gapFormatter.format(Math.abs(value))} p.p.`;
}

export function formatCount(value: number): string {
	return countFormatter.format(value);
}

export function formatDayLabel(value: string): string {
	const date = dateOnlyToDate(value);
	return date ? format(date, "dd/MM") : value;
}

export function formatShortDate(value: string): string {
	const date = dateOnlyToDate(value);
	return date ? format(date, "dd/MM/yy") : value;
}

export function formatLongDate(value: string): string {
	const date = dateOnlyToDate(value);
	return date ? format(date, "d 'de' MMMM", { locale: ptBR }) : value;
}

export function daysUntil(target: string, reference: string): number | null {
	const targetDate = dateOnlyToDate(target);
	const referenceDate = dateOnlyToDate(reference);
	if (!targetDate || !referenceDate) return null;
	return differenceInCalendarDays(targetDate, referenceDate);
}

export function formatDays(value: number | null): string {
	if (value === null) return "—";
	if (value === 0) return "hoje";
	return countFormatter.format(value);
}
